import ActionTypes from "../constants/ActionTypes";
import BASE_URL from "../constants/Api";
import axiosInstance from "../helpers/refreshTokenMiddleware";

/* =========================================================
 * 管理者マスタ一覧取得 (Admin List Fetch)
 * ========================================================= */
export const fetchAdminListRequest = () => ({
  type: ActionTypes.FETCH_ADMIN_LIST_REQUEST,
});

export const fetchAdminListSuccess = (data_list, all_data_count) => ({
  type: ActionTypes.FETCH_ADMIN_LIST_SUCCESS,
  payload: { data_list, all_data_count },
});

export const fetchAdminListFailure = (error) => ({
  type: ActionTypes.FETCH_ADMIN_LIST_FAILURE,
  payload: error,
  error: true,
});

export const fetchAdminList = () => async (dispatch) => {
  dispatch(fetchAdminListRequest());

  try {
    const accessToken = localStorage.getItem("accessToken");

    if (!accessToken) {
      window.location.href = "/login";
      return;
    }

    const response = await axiosInstance.get(`${BASE_URL}?path=admin&type=get-list-data`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    const { data_list, all_data_count } = response.data.respons;
    dispatch(fetchAdminListSuccess(data_list, all_data_count ));

  } catch (error) {
    dispatch(fetchAdminListFailure(error.message));
  }
};
